import React from 'react';
import { Link } from 'react-router-dom';

const Paginate = ({ pages, page, path = '', extraParams = '' }) => {
  if (pages <= 1) return null;
  
  // Build parameter string
  const buildParamString = (pageNum) => {
    const pageParam = `page=${pageNum}`;
    if (extraParams) {
      return `${pageParam}&${extraParams}`;
    }
    return pageParam;
  };
  
  // Generate page links
  const renderPageLinks = () => {
    const pageLinks = [];
    
    // Previous button
    pageLinks.push(
      <li key="prev" className={page <= 1 ? 'disabled' : ''}>
        {page <= 1 ? (
          <span className="px-3 py-2 bg-gray-200 text-gray-500 rounded-md mr-2">
            上一页
          </span>
        ) : (
          <Link
            to={`${path}?${buildParamString(page - 1)}`}
            className="px-3 py-2 bg-gray-200 hover:bg-gray-300 rounded-md mr-2"
          >
            上一页
          </Link>
        )}
      </li>
    );
    
    // Determine range of page numbers to show
    let startPage = Math.max(1, page - 2);
    let endPage = Math.min(pages, startPage + 4);
    
    // Adjust if we're near the end
    if (endPage - startPage < 4) {
      startPage = Math.max(1, endPage - 4);
    }
    
    // First page if not in range
    if (startPage > 1) {
      pageLinks.push(
        <li key="1">
          <Link
            to={`${path}?${buildParamString(1)}`}
            className={`px-3 py-2 ${
              page === 1 ? 'bg-red-700 text-white' : 'bg-gray-200 hover:bg-gray-300'
            } rounded-md mr-2`}
          >
            1
          </Link>
        </li>
      );
      
      if (startPage > 2) {
        pageLinks.push(
          <li key="ellipsis1" className="px-3 py-2 mr-2">
            ...
          </li>
        );
      }
    }
    
    // Page numbers
    for (let i = startPage; i <= endPage; i++) {
      pageLinks.push(
        <li key={i}>
          <Link
            to={`${path}?${buildParamString(i)}`}
            className={`px-3 py-2 ${
              page === i ? 'bg-red-700 text-white' : 'bg-gray-200 hover:bg-gray-300'
            } rounded-md mr-2`}
          >
            {i}
          </Link>
        </li>
      );
    }
    
    // Last page if not in range
    if (endPage < pages) {
      if (endPage < pages - 1) {
        pageLinks.push(
          <li key="ellipsis2" className="px-3 py-2 mr-2">
            ...
          </li>
        );
      }
      
      pageLinks.push(
        <li key={pages}>
          <Link
            to={`${path}?${buildParamString(pages)}`}
            className={`px-3 py-2 ${
              page === pages ? 'bg-red-700 text-white' : 'bg-gray-200 hover:bg-gray-300'
            } rounded-md mr-2`}
          >
            {pages}
          </Link>
        </li>
      );
    }
    
    // Next button
    pageLinks.push(
      <li key="next" className={page >= pages ? 'disabled' : ''}>
        {page >= pages ? (
          <span className="px-3 py-2 bg-gray-200 text-gray-500 rounded-md">
            下一页
          </span>
        ) : (
          <Link
            to={`${path}?${buildParamString(page + 1)}`}
            className="px-3 py-2 bg-gray-200 hover:bg-gray-300 rounded-md"
          >
            下一页
          </Link>
        )}
      </li>
    );
    
    return pageLinks;
  };
  
  return (
    <div className="flex justify-center mt-8">
      <ul className="flex flex-wrap">
        {renderPageLinks()}
      </ul>
    </div>
  );
};

export default Paginate;